import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { cn } from '@marvelapp/ballpark-components';
export const CardSortingCategoryGrid = observer(function CardSortingCategoryGrid(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (_jsx("div", Object.assign({ className: cn('py-4', 'pr-4', 'grid', 'gap-4', 'max-h-full', 'overflow-auto', 'w-[calc(50%-8px)]', 'xl:w-[66%]', 'xl:grid-cols-2', '2xl:w-[75%]', '2xl:grid-cols-3', className) }, rest)));
});
